import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import CardContainer from "../CardContainer";
import { EMPTY_LIST } from "app/app.constants";
import GroupHeader from "features/planner/components/Group/GroupHeader";
import { getGroupProjectsFromState } from "features/planner/planner.selectors";
import DraggableViewGroup from "features/planner/components/DraggableViewGroup";
import ProjectsContainer from "features/planner/components/Project/ProjectsContainer";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      "&:not(:last-child)": {
        marginBottom: theme.spacing(1),
      },
    },
    cardContainersCollapsed: {
      display: "none",
    },
  }),
);

const Group = (props) => {
  const {
    type,
    viewId,
    groupId,
    expanded,
    viewColumn,
    isEditMode,
    viewGroupId,
    viewColumnOrder,
    projects,
  } = props;
  const classes = useStyles();
  const group = useSelector((state) =>
    state.getIn(["groups", groupId?.toString()]),
  );
  const ids = group.get("cardContainersById").keySeq();

  const renderGroupHeader = ({ isDragging }) => {
    return (
      <GroupHeader
        viewId={viewId}
        groupId={groupId}
        expanded={expanded}
        draggable={isEditMode}
        isDragging={isDragging}
        viewColumn={viewColumn}
        displayMenu={!isEditMode}
        viewGroupId={viewGroupId}
        displayExpandBtn={!isEditMode}
      />
    );
  };

  return (
    <Grid container className={classes.root}>
      <DraggableViewGroup
        type={type}
        viewId={viewId}
        expanded={expanded}
        disabled={!isEditMode}
        viewColumn={viewColumn}
        viewGroupId={viewGroupId}
        viewColumnOrder={viewColumnOrder}
        renderContent={renderGroupHeader}
      />
      <ProjectsContainer projects={projects} />
      <Grid
        container
        wrap="nowrap"
        className={classNames({
          [classes.cardContainersCollapsed]: !expanded,
        })}
      >
        {ids.map((cardContainerId) => (
          <Grid
            key={`group-${groupId}-${cardContainerId}`}
            xs
            item
            groupType={type}
            groupId={groupId}
            component={CardContainer}
            cardContainerId={cardContainerId}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default compose(
  connect((state, { groupId }) => {
    return {
      projects: groupId
        ? getGroupProjectsFromState(state, groupId)
        : EMPTY_LIST,
    };
  }),
)(Group);
